import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { RESIDENTS_DESKTOP_COLORS } from '@/constants/residents/desktop/color';
import { RESIDENTS_SVG_COMPONENTS } from '@/assets/residents';
import { useResponsive } from '@/hooks/common/useResponsive';

export enum TicketTypes {
  OPEN = 'open',
  SOLVED = 'solved',
}

interface MaintenanceEmptyStateProps {
  ticketType: TicketTypes;
}

export const MaintenanceEmptyState: React.FC<MaintenanceEmptyStateProps> = ({ ticketType }) => {
  const { layoutMode } = useResponsive();
  const isDesktop = layoutMode === 'desktop';

  const getMessage = () => {
    return `You have no ${ticketType} service requests at the moment`;
  };

  if (!isDesktop) {
    // Mobile empty state
    return (
      <View style={styles.mobileContainer}>
        <RESIDENTS_SVG_COMPONENTS.EMPTY_CONVERSATION width={64} height={64} />
        <Text style={styles.mobileTitle}>No service requests</Text>
        <Text style={styles.mobileMessage}>{getMessage()}</Text>
      </View>
    );
  }

  // Desktop empty state
  return (
    <View style={styles.desktopContainer}>
      <View style={styles.iconContainer}>
        <RESIDENTS_SVG_COMPONENTS.EMPTY_CONVERSATION width={80} height={80} />
      </View>
      <Text style={styles.desktopTitle}>No service requests</Text>
      <Text style={styles.desktopMessage}>{getMessage()}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  // Mobile styles
  mobileContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 32,
    paddingVertical: 64,
  },
  mobileTitle: {
    fontSize: 20,
    fontWeight: '600',
    color: '#111827',
    marginTop: 24,
    marginBottom: 8,
    textAlign: 'center',
  },
  mobileMessage: {
    fontSize: 16,
    color: '#6B7280',
    textAlign: 'center',
    lineHeight: 24,
  },

  // Desktop styles
  desktopContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 80,
    paddingHorizontal: 32,
    width: '70%',
    marginHorizontal: 'auto',
  },
  iconContainer: {
    marginBottom: 24,
  },
  desktopTitle: {
    fontSize: 24,
    fontWeight: '600',
    color: RESIDENTS_DESKTOP_COLORS.TEXT_PRIMARY,
    marginBottom: 12,
    textAlign: 'center',
  },
  desktopMessage: {
    fontSize: 16,
    color: RESIDENTS_DESKTOP_COLORS.TEXT_TERTIARY,
    textAlign: 'center',
    lineHeight: 24,
    maxWidth: 400,
  },
});
